var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      {
        staticClass: "tooltip-container",
        class: _vm.computedTooltipContainerClasses,
        on: { click: _vm.onTooltipModalClick },
      },
      _vm.listeners
    ),
    [
      _c(
        "div",
        {
          ref: "tooltipPositioner",
          staticClass: "tooltip-positioner",
          style: _vm.tooltipPosition,
          on: { click: _vm.onTooltipPositionerClick },
        },
        [
          _c(
            "div",
            {
              ref: "tooltipWrapper",
              staticClass: "tooltip-wrapper",
              class: _vm.computedTooltipWrapperClasses,
              style: _vm.computedTooltipWrapperStyles,
            },
            [
              _c("div", { staticClass: "tooltip-component" }, [
                _vm.hasHeader
                  ? _c(
                      "div",
                      {
                        staticClass: "tooltip-header",
                        class: _vm.computedTooltipHeaderClasses,
                      },
                      [
                        _vm.title
                          ? _c("div", { staticClass: "tooltip-title" }, [
                              _vm._v(_vm._s(_vm.title)),
                            ])
                          : _vm._e(),
                        _vm.hasCloseButton
                          ? _c(
                              "IconComponent",
                              {
                                staticClass: "tooltip-close-button",
                                on: { click: _vm.onCloseClick },
                              },
                              [_vm._v("close")]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    ref: "tooltipBody",
                    staticClass: "tooltip-body",
                    class: _vm.bodyClasses,
                    style: _vm.bodyStyles,
                  },
                  [_vm._t("default")],
                  2
                ),
              ]),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }